import apiHttpRequest from "services/api-http-request";

const getSimulationEnergyForecast = async (params) => {
  let data = [];

  try {
    data = await apiHttpRequest.get(`/simulation`, params);
  } catch (e) {
    console.error(e);
  }

  return data
}

export default {
  getSimulationEnergyForecast
}